import { Component, EventEmitter, Output } from '@angular/core';
import { MaterialModule } from '../../material/material.module';


@Component({
  selector: 'app-card-detector',
  templateUrl: './card-detector.component.html',
  styleUrl: './card-detector.component.scss',
  standalone: false
})
export class CardDetectorComponent {
  cardNumber: string = '';
  cardType: string = '';
  cardLogo: string = '';
  codCard: string | null = null;
  codCuota: string | null = null;
  maskPattern: string = '';
  requiredLength: number = 0;

  @Output() cardDetected = new EventEmitter<{ cardNumber: string, cardType: string, cardLogo: string, codCard: string | null, codCuota: string | null, requiredLength: number }>();

  // Se llama en cada entrada
  onCardNumberChange(value: string): void {
    this.cardNumber = value;
    const cleaned = value.replace(/\D/g, '');

    if (cleaned.length >= 4) {
      this.cardType = this.detectCardType(cleaned);
      this.updateCardInfo(this.cardType);
    } else {
      // Si hay menos de 4 dígitos, se limpian los valores
      this.cardType = '';
      this.cardLogo = '';
      this.maskPattern = '';
      this.codCard = null;
      this.codCuota = null;
      this.requiredLength = 0;
    }

    // Emitir los datos (esto se hará en cada cambio, puedes afinar cuándo emitir)
    this.cardDetected.emit({
      cardNumber: this.cardNumber,
      cardType: this.cardType,
      cardLogo: this.cardLogo,
      codCard: this.codCard,
      codCuota: this.codCuota,
      requiredLength: this.requiredLength
    });
  }

  detectCardType(cleaned: string): string {
    // Ejemplo: detecta Visa si el primer dígito es "4"
    if (cleaned.charAt(0) === '4') {
      return 'Visa';
    }
    // American Express: primeros dos dígitos 34 o 37
    if (cleaned.length >= 2) {
      const firstTwo = cleaned.substr(0, 2);
      if (firstTwo === '34' || firstTwo === '37') {
        return 'American Express';
      }
    }
    // MasterCard: primeros dos dígitos entre 51 y 55
    if (cleaned.length >= 2) {
      const firstTwo = parseInt(cleaned.substr(0, 2), 10);
      if (firstTwo >= 51 && firstTwo <= 55) {
        return 'MasterCard';
      }
    }
    // Cabal: por ejemplo, si comienza con 604 o 589
    if (cleaned.length >= 3) {
      const firstThree = cleaned.substr(0, 3);
      if (firstThree === '604' || firstThree === '589') {
        return 'Cabal';
      }
    }
    return 'Desconocida';
  }

  updateCardInfo(cardType: string): void {
    switch(cardType) {
      case 'Visa':
        this.cardLogo = 'assets/logos/visa.png';
        this.maskPattern = '0000 - 0000 - 0000 - 0000';
        this.requiredLength = 25;
        this.codCard = '4';
        this.codCuota = '124';
        break;
      case 'MasterCard':
        this.cardLogo = 'assets/logos/mastercard.png';
        this.maskPattern = '0000 - 0000 - 0000 - 0000';
        this.requiredLength = 25;
        this.codCard = '3';
        this.codCuota = '123';
        break;
      case 'American Express':
        this.cardLogo = 'assets/logos/amex.png';
        this.maskPattern = '0000 - 000000 - 00000';
        this.requiredLength = 21;
        this.codCard = '1';
        this.codCuota = '76';
        break;
      case 'Cabal':
        this.cardLogo = 'assets/logos/cabal.png';
        this.maskPattern = '0000 - 0000 - 0000 - 0000';
        this.requiredLength = 25;
        this.codCard = '15';
        this.codCuota = '128';
        break;
      default:
        this.cardLogo = '';
        this.maskPattern = '';
        this.codCard = '0';
        this.codCuota = '0';
        break;
    }
  }
}
